import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './components/HomePage.vue';
import BurnPage from './components/BurnPage.vue';
import WhitepaperPage from './components/WhitepaperPage.vue';
 
const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  {
    path: '/burn',
    name: 'BurnPage',
    component: BurnPage,
  },
  {
    path: '/whitepaper',
    name: 'WhitepaperPage',
    component: WhitepaperPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
